import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DAFAULT_PAGINATION_OPTIONS } from '../../../../core/constants/constants';

@Component({
  selector: 'shared-custom-pagination',
  templateUrl: './custom-pagination.component.html',
  styleUrl: './custom-pagination.component.scss',
})
export class CustomPaginationComponent {
  @Input()
  public paginationOptions: number[] = DAFAULT_PAGINATION_OPTIONS;

  @Input()
  public collectionSize: number = 0;

  @Input()
  public currentPage: number = 1;

  @Input()
  public currentPageSize?: number;

  @Output()
  public pageChange = new EventEmitter<number>();

  @Output()
  public pageSizeChange = new EventEmitter<number>();

  public page: number = 1;
  public pageSize: number = this.paginationOptions[0] || 1;
  public previusPage: number = 1;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentPage'] && this.currentPage) {
      this.page = this.currentPage;
    }

    if (changes['currentPageSize'] && this.currentPageSize) {
      this.pageSize = this.currentPageSize;
    } else if (changes['paginationOptions'] && this.paginationOptions?.length) {
      this.pageSize = this.paginationOptions[0];
    }
  }

  public selectPage(page: string) {
    this.previusPage = this.page;
    const currentPage = parseInt(page, 10) || 1;
    if (
      this.previusPage !== currentPage &&
      Math.ceil(this.collectionSize / this.pageSize) >= currentPage
    ) {
      this.pageChange.emit(currentPage);
    }
    this.page = currentPage;
  }

  public formatInput(input: HTMLInputElement) {
    input.value = input.value.replace(FILTER_PAG_REGEX, '');
  }

  public onPageChange($event: number) {
    this.pageChange.emit($event);
    this.page = $event;
  }

  public onPageSizeChange($event: number) {
    if ($event === 0 || !$event) return;
    this.page = 1;
    this.pageSize = $event;
    this.pageSizeChange.emit($event);
  }
}

const FILTER_PAG_REGEX = /[^0-9]/g;
